import { useMemo } from 'react'
import { useTheme } from 'styled-components'

export default function useAdyenCardStyles(): Record<string, Partial<CSSStyleDeclaration>> {
  const theme = useTheme()

  return useMemo(
    () => ({
      base: {
        color: `${theme.colors.black.cool}`,
        fontSize: '0.875rem',
        fontFamily: 'Helvetica'
      },
      placeholder: {
        color: `${theme.colors.grey.dark}`
      }
    }),
    [theme.colors.black.cool, theme.colors.grey.dark]
  )
}
